module.exports = __webpack_public_path__ + "static/media/Mark3.22ffa794.jpg";